export const defaultJson = [
  {
    "stepId": "Basic Details",
    "stepName": "Application Form",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "form",
    "sections": [
      {
        "sectionName": "Candidate Information",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "applicant[salutation]",
            "required": true,
            "name": "applicant[salutation]",
            "label": "Salutation",
            "type": "select",
            "visible": true,
            "disabled": true,
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Salutation"
              }
            },
            "options": [
              {
                "label": "Mr.",
                "value": "Mr."
              },
              {
                "label": "Mrs.",
                "value": "Mrs."
              },
              {
                "label": "Ms.",
                "value": "Ms."
              }
            ]
          },
          {
            "fieldId": "applicant[combineFirstLast]",
            "required": true,
            "name": "applicant[combineFirstLast]",
            "label": "Full Name",
            "type": "input",
            "disabled": true,
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Name"
              }
            }
          },
          {
            "fieldId": "applicant[candidateId]",
            "required": true,
            "name": "applicant[candidateId]",
            "label": "Candidate ID",
            "type": "input",
            "disabled": true,
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid  Name"
              }
            }
          },
          {
            "fieldId": "applicant[email]",
            "required": true,
            "name": "applicant[email]",
            "label": "Email",
            "disabled": true,
            "type": "input",
            "validationType": "email",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Email"
              }
            }
          },
          {
            "fieldId": "applicant[phone]",
            "required": true,
            "name": "applicant[phone]",
            "label": "Mobile Number",
            "type": "phone",
            "apiKey": "applicant[phone]",
            "disabled": true,
            "validationType": "phone",
            "validations": {
              "required": "This field is required",
              "pattern": {
                "value": "",
                "message": "Please Input a valid Mobile Number"
              }
            }
          },
          {
            "fieldId": "applicant[trainingCentre]",
            "required": true,
            "name": "applicant[trainingCentre]",
            "label": "Training Centre",
            "type": "select",
            "disabled": true,
            "options": [
              {
                "label": "University of Lucknow (Old campus)",
                "value": "University of Lucknow (Old campus)"
              },
              {
                "label": "University of Lucknow (New campus)",
                "value": "University of Lucknow (New campus)"
              },
              {
                "label": "National Post Graduate College",
                "value": "National Post Graduate College"
              },
              {
                "label": "Khwaja Moinuddin Chishti Language University",
                "value": "Khwaja Moinuddin Chishti Language University"
              },
              {
                "label": "Govt. Degree College Todarpur",
                "value": "Govt. Degree College Todarpur"
              },
              {
                "label": "Deen Dayal Upadhyay Gorakhpur University",
                "value": "Deen Dayal Upadhyay Gorakhpur University"
              },
              {
                "label": "ITM GIDA",
                "value": "ITM GIDA"
              },
              {
                "label": "Agra University",
                "value": "Agra University"
              },
              {
                "label": "Babasaheb Bhimrao Ambedkar University",
                "value": "Babasaheb Bhimrao Ambedkar University"
              },
              {
                "label": "Maharani Cluster University",
                "value": "Maharani Cluster University"
              },
              {
                "label": "Nrupathunga University",
                "value": "Nrupathunga University"
              },
              {
                "label": "Dayananda Sagar College of Engineering",
                "value": "Dayananda Sagar College of Engineering"
              },
              {
                "label": "National Institute of Engineering",
                "value": "National Institute of Engineering"
              },
              {
                "label": "Sardar Patel College of Engineering",
                "value": "Sardar Patel College of Engineering"
              },
              {
                "label": "Veermata Jijabai Technological Institute",
                "value": "Veermata Jijabai Technological Institute"
              },
              {
                "label": "Government College of Engineering and Research",
                "value": "Government College of Engineering and Research"
              },
              {
                "label": "Bhaskaracharya College Of Applied Sciences",
                "value": "Bhaskaracharya College Of Applied Sciences"
              },
              {
                "label": "Guru Gobind Singh Indraprastha University (East Delhi Campus)",
                "value": "Guru Gobind Singh Indraprastha University (East Delhi Campus)"
              },
              {
                "label": "Netaji Subhas University of Technology",
                "value": "Netaji Subhas University of Technology"
              },
              {
                "label": "Maharaja Agrasen College",
                "value": "Maharaja Agrasen College"
              },
              {
                "label": "Anna University",
                "value": "Anna University"
              },
              {
                "label": "Visakha Govt. Degree College For Women",
                "value": "Visakha Govt. Degree College For Women"
              }
            ]
          },
          {
            "fieldId": "applicant[course]",
            "name": "applicant[course]",
            "label": "Course",
            "required": true,
            "type": "select",
            "disabled": false,
            "options": [
              {
                "label": "Artificial Intelligence",
                "value": "Artificial Intelligence"
              }
            ]
          },
          {
            "fieldId": "applicant[dateOfBirth]",
            "required": true,
            "name": "applicant[dateOfBirth]",
            "label": "Date of Birth",
            "type": "date",
            "maxDate": "-18",
            "minDate": "25",
            "validations": {
              "required": "This field is required"
            }
          },
          {
            "fieldId": "applicant[ageAsOnDate]",
            "required": true,
            "name": "applicant[ageAsOnDate]",
            "label": "Age",
            "type": "input",
            "disabled": true,
            "validations": {
              "required": "This field is required"
            }
          },
          {
            "fieldId": "application[proofOfIdentity]",
            "required": true,
            "name": "application[proofOfIdentity]",
            "label": "Proof Of Identity",
            "type": "select",
            "visible": true,
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "Aadhaar",
                "value": "Aadhaar"
              },
              {
                "label": "VoterID",
                "value": "VoterID"
              },
              {
                "label": "Driving License",
                "value": "Driving License"
              }
            ]
          },
          {
            "name": "applicant[aadharNumber]",
            "label": "Aadhaar Number",
            "required": true,
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[proofOfIdentity]",
                "expectedValue": "Aadhaar",
                "type": "LEAF"
              }
            },
            "type": "input",
            "validationType": "number",
            "visible": true,
            "fieldId": "aadharNumber",
            "validations": {
              "required": {
                "value": true,
                "message": "Field is required"
              },
              "minLength": {
                "value": 12,
                "message": "Invalid Aadhaar number. Please enter a 12-digit Aadhaar number."
              },
              "maxLength": {
                "value": 12,
                "message": "Invalid Aadhaar number. Please enter a 12-digit Aadhaar number."
              },
              "pattern": {
                "value": "",
                "message": "Please input a correct value"
              }
            }
          },
          {
            "name": "applicant[votersId]",
            "label": "Voter ID",
            "required": true,
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[proofOfIdentity]",
                "expectedValue": "VoterID",
                "type": "LEAF"
              }
            },
            "type": "input",
            "validationType": "alphaNumeric",
            "visible": true,
            "fieldId": "voterId",
            "validations": {
              "required": {
                "value": true,
                "message": "Field is required"
              },
              "minLength": {
                "value": 10,
                "message": "Invalid Voter ID. Please enter the correct Voter ID details."
              },
              "maxLength": {
                "value": 10,
                "message": "Invalid Voter ID. Please enter the correct Voter ID details."
              },
              "pattern": {
                "value": "",
                "message": "Please input a correct value"
              }
            }
          },
          {
            "name": "applicant[drivingLicense]",
            "label": "Driving License",
            "required": true,
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "application[proofOfIdentity]",
                "expectedValue": "Driving License",
                "type": "LEAF"
              }
            },
            "type": "input",
            "validationType": "",
            "visible": true,
            "fieldId": "drivingLicense",
            "validations": {
              "required": {
                "value": true,
                "message": "Field is required"
              },
              "minLength": {
                "value": 8,
                "message": "Invalid Driving License. Please enter the correct Driving License details."
              },
              "maxLength": {
                "value": 20,
                "message": "Invalid Driving License. Please enter the correct Driving License details."
              },
              "pattern": {
                "value": "",
                "message": "Please input a correct value"
              }
            }
          },
          {
            "fieldId": "applicant[gender]",
            "required": true,
            "name": "applicant[gender]",
            "label": "Gender",
            "type": "radio",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "Male",
                "value": "Male"
              },
              {
                "label": "Female",
                "value": "Female"
              },
              {
                "label": "Prefer not to say",
                "value": "Prefer not to say"
              }
            ]
          },
          {
            "fieldId": "applicant[fatherName]",
            "required": true,
            "name": "applicant[fatherName]",
            "label": "Father's Name",
            "type": "input",
            "validationType": "alpha",
            "disabled": false,
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": "2",
                "message": "Please enter a valid name"
              },
              "maxLength": {
                "value": "40",
                "message": "This field can't be more than 40 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please Input a valid Name"
              }
            }
          },
          {
            "fieldId": "applicant[motherName]",
            "required": true,
            "name": "applicant[motherName]",
            "label": "Mother's Name",
            "type": "input",
            "validationType": "alpha",
            "disabled": false,
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": "2",
                "message": "Please enter a valid name"
              },
              "maxLength": {
                "value": "40",
                "message": "This field can't be more than 40 characters"
              },
              "pattern": {
                "value": "",
                "message": "Please Input a valid Name"
              }
            }
          },
          {
            "fieldId": "applicant[category]",
            "required": true,
            "name": "applicant[category]",
            "label": "Category",
            "type": "select",
            "visible": true,
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "General",
                "value": "General"
              },
              {
                "label": "OBC",
                "value": "OBC"
              },
              {
                "label": "SC",
                "value": "SC"
              },
              {
                "label": "ST",
                "value": "ST"
              },
              {
                "label": "EWS",
                "value": "EWS"
              }
            ]
          },
          {
            "fieldId": "applicant[highestQualification]",
            "required": true,
            "name": "applicant[highestQualification]",
            "label": "Highest Qualification",
            "type": "select",
            "disabled": false,
            "options": [
              {
                "label": "B.Tech",
                "value": "B.Tech"
              },
              {
                "label": "B.Sc",
                "value": "B.Sc"
              },
              {
                "label": "M.Sc",
                "value": "M.Sc"
              },
              {
                "label": "BCA",
                "value": "BCA"
              },
              {
                "label": "MCA",
                "value": "MCA"
              }
            ],
            "validations": {
              "required": "This field is required"
            }
          },
          {
            "fieldId": "applicant[specialization]",
            "required": true,
            "name": "applicant[specialization]",
            "label": "Specialization",
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "B.Tech",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "B.Tech in Computer Science and Engineering (CSE)",
                "value": "B.Tech in Computer Science and Engineering (CSE)"
              },
              {
                "label": "B.Tech in Information Technology (IT)",
                "value": "B.Tech in Information Technology (IT)"
              },
              {
                "label": "B.Tech in Artificial Intelligence (AI)",
                "value": "B.Tech in Artificial Intelligence (AI)"
              },
              {
                "label": "B.Tech in Artificial Intelligence and Machine Learning (AI & ML)",
                "value": "B.Tech in Artificial Intelligence and Machine Learning (AI & ML)"
              },
              {
                "label": "B.Tech in Data Science",
                "value": "B.Tech in Data Science"
              },
              {
                "label": "B.Tech in Cyber Security",
                "value": "B.Tech in Cyber Security"
              },
              {
                "label": "B.Tech in Electronics and Communication Engineering (ECE)",
                "value": "B.Tech in Electronics and Communication Engineering (ECE)"
              },
              {
                "label": "B.Tech in Electrical and Electronics Engineering (EEE)",
                "value": "B.Tech in Electrical and Electronics Engineering (EEE)"
              },
              {
                "label": "B.Tech in Electrical Engineering (EE)",
                "value": "B.Tech in Electrical Engineering (EE)"
              },
              {
                "label": "B.Tech in Mechanical Engineering",
                "value": "B.Tech in Mechanical Engineering"
              },
              {
                "label": "B.Tech in Civil Engineering",
                "value": "B.Tech in Civil Engineering"
              },
              {
                "label": "B.Tech in Chemical Engineering",
                "value": "B.Tech in Chemical Engineering"
              },
              {
                "label": "B.Tech in Biotechnology",
                "value": "B.Tech in Biotechnology"
              },
              {
                "label": "B.Tech in Aerospace Engineering",
                "value": "B.Tech in Aerospace Engineering"
              },
              {
                "label": "B.Tech in Aeronautical Engineering",
                "value": "B.Tech in Aeronautical Engineering"
              },
              {
                "label": "B.Tech in Automobile Engineering",
                "value": "B.Tech in Automobile Engineering"
              },
              {
                "label": "B.Tech in Mechatronics Engineering",
                "value": "B.Tech in Mechatronics Engineering"
              },
              {
                "label": "B.Tech in Robotics and Automation",
                "value": "B.Tech in Robotics and Automation"
              },
              {
                "label": "B.Tech in Industrial Engineering",
                "value": "B.Tech in Industrial Engineering"
              },
              {
                "label": "B.Tech in Production Engineering",
                "value": "B.Tech in Production Engineering"
              },
              {
                "label": "B.Tech in Manufacturing Engineering",
                "value": "B.Tech in Manufacturing Engineering"
              },
              {
                "label": "B.Tech in Mining Engineering",
                "value": "B.Tech in Mining Engineering"
              },
              {
                "label": "B.Tech in Petroleum Engineering",
                "value": "B.Tech in Petroleum Engineering"
              },
              {
                "label": "B.Tech in Environmental Engineering",
                "value": "B.Tech in Environmental Engineering"
              },
              {
                "label": "B.Tech in Agricultural Engineering",
                "value": "B.Tech in Agricultural Engineering"
              },
              {
                "label": "B.Tech in Food Technology",
                "value": "B.Tech in Food Technology"
              },
              {
                "label": "B.Tech in Textile Engineering",
                "value": "B.Tech in Textile Engineering"
              },
              {
                "label": "B.Tech in Marine Engineering",
                "value": "B.Tech in Marine Engineering"
              },
              {
                "label": "B.Tech in Naval Architecture",
                "value": "B.Tech in Naval Architecture"
              },
              {
                "label": "B.Tech in Metallurgical Engineering",
                "value": "B.Tech in Metallurgical Engineering"
              },
              {
                "label": "B.Tech in Ceramic Engineering",
                "value": "B.Tech in Ceramic Engineering"
              },
              {
                "label": "B.Tech in Instrumentation Engineering",
                "value": "B.Tech in Instrumentation Engineering"
              },
              {
                "label": "B.Tech in Electronics and Instrumentation Engineering (EIE)",
                "value": "B.Tech in Electronics and Instrumentation Engineering (EIE)"
              },
              {
                "label": "B.Tech in Biomedical Engineering",
                "value": "B.Tech in Biomedical Engineering"
              },
              {
                "label": "B.Tech in Printing Technology",
                "value": "B.Tech in Printing Technology"
              },
              {
                "label": "B.Tech in Plastics Engineering",
                "value": "B.Tech in Plastics Engineering"
              }
            ]
          },
          {
            "name": "applicant[specialization]",
            "label": "Specialization",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "B.Sc",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "B.Sc in Physics",
                "value": "B.Sc in Physics"
              },
              {
                "label": "B.Sc in Chemistry",
                "value": "B.Sc in Chemistry"
              },
              {
                "label": "B.Sc in Mathematics",
                "value": "B.Sc in Mathematics"
              },
              {
                "label": "B.Sc in Statistics",
                "value": "B.Sc in Statistics"
              },
              {
                "label": "B.Sc in Computer Science",
                "value": "B.Sc in Computer Science"
              },
              {
                "label": "B.Sc in Information Technology (IT)",
                "value": "B.Sc in Information Technology (IT)"
              },
              {
                "label": "B.Sc in Data Science",
                "value": "B.Sc in Data Science"
              },
              {
                "label": "B.Sc in Artificial Intelligence",
                "value": "B.Sc in Artificial Intelligence"
              },
              {
                "label": "B.Sc in Biotechnology",
                "value": "B.Sc in Biotechnology"
              },
              {
                "label": "B.Sc in Microbiology",
                "value": "B.Sc in Microbiology"
              },
              {
                "label": "B.Sc in Biochemistry",
                "value": "B.Sc in Biochemistry"
              },
              {
                "label": "B.Sc in Zoology",
                "value": "B.Sc in Zoology"
              },
              {
                "label": "B.Sc in Botany",
                "value": "B.Sc in Botany"
              },
              {
                "label": "B.Sc in Environmental Science",
                "value": "B.Sc in Environmental Science"
              },
              {
                "label": "B.Sc in Life Sciences",
                "value": "B.Sc in Life Sciences"
              },
              {
                "label": "B.Sc in Genetics",
                "value": "B.Sc in Genetics"
              },
              {
                "label": "B.Sc in Biomedical Science",
                "value": "B.Sc in Biomedical Science"
              },
              {
                "label": "B.Sc in Nursing",
                "value": "B.Sc in Nursing"
              },
              {
                "label": "B.Sc in Agriculture",
                "value": "B.Sc in Agriculture"
              },
              {
                "label": "B.Sc in Forestry",
                "value": "B.Sc in Forestry"
              },
              {
                "label": "B.Sc in Horticulture",
                "value": "B.Sc in Horticulture"
              },
              {
                "label": "B.Sc in Food Technology",
                "value": "B.Sc in Food Technology"
              },
              {
                "label": "B.Sc in Nutrition and Dietetics",
                "value": "B.Sc in Nutrition and Dietetics"
              },
              {
                "label": "B.Sc in Psychology",
                "value": "B.Sc in Psychology"
              },
              {
                "label": "B.Sc in Geology",
                "value": "B.Sc in Geology"
              },
              {
                "label": "B.Sc in Geography",
                "value": "B.Sc in Geography"
              },
              {
                "label": "B.Sc in Oceanography",
                "value": "B.Sc in Oceanography"
              },
              {
                "label": "B.Sc in Marine Biology",
                "value": "B.Sc in Marine Biology"
              },
              {
                "label": "B.Sc in Astronomy",
                "value": "B.Sc in Astronomy"
              },
              {
                "label": "B.Sc in Electronics",
                "value": "B.Sc in Electronics"
              },
              {
                "label": "B.Sc in Animation",
                "value": "B.Sc in Animation"
              },
              {
                "label": "B.Sc in Multimedia",
                "value": "B.Sc in Multimedia"
              },
              {
                "label": "B.Sc in Hospitality and Hotel Administration",
                "value": "B.Sc in Hospitality and Hotel Administration"
              },
              {
                "label": "B.Sc in Fashion Design",
                "value": "B.Sc in Fashion Design"
              },
              {
                "label": "B.Sc in Interior Design",
                "value": "B.Sc in Interior Design"
              },
              {
                "label": "B.Sc in Aviation",
                "value": "B.Sc in Aviation"
              },
              {
                "label": "B.Sc in Forensic Science",
                "value": "B.Sc in Forensic Science"
              },
              {
                "label": "B.Sc in Medical Laboratory Technology (MLT)",
                "value": "B.Sc in Medical Laboratory Technology (MLT)"
              },
              {
                "label": "B.Sc in Radiology and Imaging Technology",
                "value": "B.Sc in Radiology and Imaging Technology"
              },
              {
                "label": "B.Sc in Optometry",
                "value": "B.Sc in Optometry"
              },
              {
                "label": "B.Sc in Physiotherapy",
                "value": "B.Sc in Physiotherapy"
              }
            ]
          },
          {
            "name": "applicant[specialization]",
            "label": "Specialization",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "M.Sc",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "M.Sc in Physics",
                "value": "M.Sc in Physics"
              },
              {
                "label": "M.Sc in Chemistry",
                "value": "M.Sc in Chemistry"
              },
              {
                "label": "M.Sc in Mathematics",
                "value": "M.Sc in Mathematics"
              },
              {
                "label": "M.Sc in Statistics",
                "value": "M.Sc in Statistics"
              },
              {
                "label": "M.Sc in Computer Science",
                "value": "M.Sc in Computer Science"
              },
              {
                "label": "M.Sc in Information Technology (IT)",
                "value": "M.Sc in Information Technology (IT)"
              },
              {
                "label": "M.Sc in Data Science",
                "value": "M.Sc in Data Science"
              },
              {
                "label": "M.Sc in Artificial Intelligence",
                "value": "M.Sc in Artificial Intelligence"
              },
              {
                "label": "M.Sc in Machine Learning",
                "value": "M.Sc in Machine Learning"
              },
              {
                "label": "M.Sc in Cyber Security",
                "value": "M.Sc in Cyber Security"
              },
              {
                "label": "M.Sc in Biotechnology",
                "value": "M.Sc in Biotechnology"
              },
              {
                "label": "M.Sc in Microbiology",
                "value": "M.Sc in Microbiology"
              },
              {
                "label": "M.Sc in Biochemistry",
                "value": "M.Sc in Biochemistry"
              },
              {
                "label": "M.Sc in Zoology",
                "value": "M.Sc in Zoology"
              },
              {
                "label": "M.Sc in Botany",
                "value": "M.Sc in Botany"
              },
              {
                "label": "M.Sc in Environmental Science",
                "value": "M.Sc in Environmental Science"
              },
              {
                "label": "M.Sc in Life Sciences",
                "value": "M.Sc in Life Sciences"
              },
              {
                "label": "M.Sc in Genetics",
                "value": "M.Sc in Genetics"
              },
              {
                "label": "M.Sc in Biomedical Science",
                "value": "M.Sc in Biomedical Science"
              },
              {
                "label": "M.Sc in Agriculture",
                "value": "M.Sc in Agriculture"
              },
              {
                "label": "M.Sc in Food Technology",
                "value": "M.Sc in Food Technology"
              },
              {
                "label": "M.Sc in Nutrition and Dietetics",
                "value": "M.Sc in Nutrition and Dietetics"
              },
              {
                "label": "M.Sc in Psychology",
                "value": "M.Sc in Psychology"
              },
              {
                "label": "M.Sc in Geology",
                "value": "M.Sc in Geology"
              },
              {
                "label": "M.Sc in Geography",
                "value": "M.Sc in Geography"
              },
              {
                "label": "M.Sc in Oceanography",
                "value": "M.Sc in Oceanography"
              },
              {
                "label": "M.Sc in Marine Biology",
                "value": "M.Sc in Marine Biology"
              },
              {
                "label": "M.Sc in Astronomy",
                "value": "M.Sc in Astronomy"
              },
              {
                "label": "M.Sc in Electronics",
                "value": "M.Sc in Electronics"
              },
              {
                "label": "M.Sc in Forensic Science",
                "value": "M.Sc in Forensic Science"
              },
              {
                "label": "M.Sc in Medical Laboratory Technology (MLT)",
                "value": "M.Sc in Medical Laboratory Technology (MLT)"
              },
              {
                "label": "M.Sc in Radiology and Imaging Technology",
                "value": "M.Sc in Radiology and Imaging Technology"
              },
              {
                "label": "M.Sc in Nursing",
                "value": "M.Sc in Nursing"
              },
              {
                "label": "M.Sc in Physiotherapy",
                "value": "M.Sc in Physiotherapy"
              },
              {
                "label": "M.Sc in Applied Mathematics",
                "value": "M.Sc in Applied Mathematics"
              },
              {
                "label": "M.Sc in Applied Physics",
                "value": "M.Sc in Applied Physics"
              },
              {
                "label": "M.Sc in Applied Chemistry",
                "value": "M.Sc in Applied Chemistry"
              },
              {
                "label": "M.Sc in Bioinformatics",
                "value": "M.Sc in Bioinformatics"
              },
              {
                "label": "M.Sc in Clinical Research",
                "value": "M.Sc in Clinical Research"
              },
              {
                "label": "M.Sc in Environmental Biotechnology",
                "value": "M.Sc in Environmental Biotechnology"
              }
            ]
          },
          {
            "name": "applicant[specialization]",
            "label": "Specialization",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "BCA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "BCA (General)",
                "value": "BCA (General)"
              },
              {
                "label": "BCA in Computer Science",
                "value": "BCA in Computer Science"
              },
              {
                "label": "BCA in Data Science",
                "value": "BCA in Data Science"
              },
              {
                "label": "BCA in Artificial Intelligence",
                "value": "BCA in Artificial Intelligence"
              },
              {
                "label": "BCA in Artificial Intelligence and Machine Learning (AI & ML)",
                "value": "BCA in Artificial Intelligence and Machine Learning (AI & ML)"
              },
              {
                "label": "BCA in Cyber Security",
                "value": "BCA in Cyber Security"
              },
              {
                "label": "BCA in Cloud Computing",
                "value": "BCA in Cloud Computing"
              },
              {
                "label": "BCA in Data Analytics",
                "value": "BCA in Data Analytics"
              },
              {
                "label": "BCA in Software Development",
                "value": "BCA in Software Development"
              },
              {
                "label": "BCA in Mobile Application Development",
                "value": "BCA in Mobile Application Development"
              },
              {
                "label": "BCA in Web Development",
                "value": "BCA in Web Development"
              },
              {
                "label": "BCA in Full Stack Development",
                "value": "BCA in Full Stack Development"
              },
              {
                "label": "BCA in Internet of Things (IoT)",
                "value": "BCA in Internet of Things (IoT)"
              },
              {
                "label": "BCA in Blockchain Technology",
                "value": "BCA in Blockchain Technology"
              },
              {
                "label": "BCA in Game Development",
                "value": "BCA in Game Development"
              },
              {
                "label": "BCA in Multimedia and Animation",
                "value": "BCA in Multimedia and Animation"
              },
              {
                "label": "BCA in Networking",
                "value": "BCA in Networking"
              },
              {
                "label": "BCA in Database Management",
                "value": "BCA in Database Management"
              },
              {
                "label": "BCA in DevOps",
                "value": "BCA in DevOps"
              },
              {
                "label": "BCA in Information Technology",
                "value": "BCA in Information Technology"
              }
            ]
          },
          {
            "name": "applicant[specialization]",
            "label": "Specialization",
            "required": true,
            "type": "select",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "MCA",
                "type": "LEAF"
              }
            },
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "MCA (General)",
                "value": "MCA (General)"
              },
              {
                "label": "MCA in Computer Science",
                "value": "MCA in Computer Science"
              },
              {
                "label": "MCA in Data Science",
                "value": "MCA in Data Science"
              },
              {
                "label": "MCA in Artificial Intelligence",
                "value": "MCA in Artificial Intelligence"
              },
              {
                "label": "MCA in Artificial Intelligence and Machine Learning (AI & ML)",
                "value": "MCA in Artificial Intelligence and Machine Learning (AI & ML)"
              },
              {
                "label": "MCA in Cyber Security",
                "value": "MCA in Cyber Security"
              },
              {
                "label": "MCA in Cloud Computing",
                "value": "MCA in Cloud Computing"
              },
              {
                "label": "MCA in Data Analytics",
                "value": "MCA in Data Analytics"
              },
              {
                "label": "MCA in Software Engineering",
                "value": "MCA in Software Engineering"
              },
              {
                "label": "MCA in Full Stack Development",
                "value": "MCA in Full Stack Development"
              },
              {
                "label": "MCA in Mobile Application Development",
                "value": "MCA in Mobile Application Development"
              },
              {
                "label": "MCA in Web Development",
                "value": "MCA in Web Development"
              },
              {
                "label": "MCA in DevOps",
                "value": "MCA in DevOps"
              },
              {
                "label": "MCA in Internet of Things (IoT)",
                "value": "MCA in Internet of Things (IoT)"
              },
              {
                "label": "MCA in Blockchain Technology",
                "value": "MCA in Blockchain Technology"
              },
              {
                "label": "MCA in Machine Learning",
                "value": "MCA in Machine Learning"
              },
              {
                "label": "MCA in Information Technology",
                "value": "MCA in Information Technology"
              },
              {
                "label": "MCA in Networking",
                "value": "MCA in Networking"
              },
              {
                "label": "MCA in Database Management",
                "value": "MCA in Database Management"
              },
              {
                "label": "MCA in System Administration",
                "value": "MCA in System Administration"
              }
            ]
          },
          {
            "name": "application[yearOfStudy]",
            "required": true,
            "label": "Year Of Study",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "B.Tech",
                "type": "LEAF"
              }
            },
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "2nd Year",
                "value": "2nd Year"
              },
              {
                "label": "3rd Year",
                "value": "3rd Year"
              },
              {
                "label": "4th Year",
                "value": "4th Year"
              }
            ]
          },
          {
            "name": "application[yearOfStudy]",
            "required": true,
            "label": "Year Of Study",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "B.Sc",
                "type": "LEAF"
              }
            },
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "2nd Year",
                "value": "2nd Year"
              },
              {
                "label": "3rd Year",
                "value": "3rd Year"
              }
            ]
          },
          {
            "name": "application[yearOfStudy]",
            "required": true,
            "label": "Year Of Study",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "BCA",
                "type": "LEAF"
              }
            },
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "2nd Year",
                "value": "2nd Year"
              },
              {
                "label": "3rd Year",
                "value": "3rd Year"
              }
            ]
          },
          {
            "name": "application[yearOfStudy]",
            "required": true,
            "label": "Year Of Study",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "M.Sc",
                "type": "LEAF"
              }
            },
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "1st Year",
                "value": "1st Year"
              },
              {
                "label": "2nd Year",
                "value": "2nd Year"
              }
            ]
          },
          {
            "name": "application[yearOfStudy]",
            "required": true,
            "label": "Year Of Study",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "applicant[highestQualification]",
                "expectedValue": "MCA",
                "type": "LEAF"
              }
            },
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "1st Year",
                "value": "1st Year"
              },
              {
                "label": "2nd Year",
                "value": "2nd Year"
              }
            ]
          }
        ]
      },
      {
        "sectionName": "Address Information",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionId": "Addresses",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "name": "addresses[0]",
            "type": "pincode",
            "options": [
              {
                "fieldId": "mailingPostalCode",
                "name": "mailingPostalCode",
                "label": "PIN / PO BOX/ ZIP",
                "helperText": "If your city and state is not getting auto populated, Please use the nearest PIN / PO BOX/ ZIP",
                "required": true,
                "validationType": "number",
                "validations": {
                  "required": "This field is required",
                  "maxLength": {
                    "value": 6,
                    "message": "This field can't be more than 6 character"
                  },
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid Pin code"
                  }
                },
                "ui": {
                  "gridType": "halfRow"
                },
                "type": "input"
              },
              {
                "fieldId": "mailingState",
                "name": "mailingState",
                "label": "State",
                "validations": {
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid value"
                  },
                  "maxLength": {
                    "value": 80,
                    "message": "This field can't be more than 80 character"
                  }
                },
                "validationType": "alpha",
                "type": "input",
                "ui": {
                  "gridType": "halfRow"
                }
              },
              {
                "fieldId": "mailingDistrict",
                "name": "mailingDistrict",
                "label": "City",
                "validations": {
                  "pattern": {
                    "value": "",
                    "message": "Please enter a valid value"
                  },
                  "maxLength": {
                    "value": 80,
                    "message": "This field can't be more than 80 character"
                  }
                },
                "validationType": "alpha",
                "ui": {
                  "gridType": "halfRow"
                },
                "type": "input"
              }
            ]
          },
          {
            "fieldId": "addresses[0][mailingStreet]",
            "required": true,
            "name": "addresses[0][mailingStreet]",
            "label": "Address",
            "type": "input",
            "validations": {
              "required": "This field is required",
              "maxLength": {
                "value": 250,
                "message": "This field cannot be more than 250 characters"
              },
              "minLength": {
                "value": 5,
                "message": "Please add valid address"
              }
            }
          }
        ]
      },
      {
        "sectionName": "Current Address",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionId": "Addresses",
        "showSectionName": false,
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "addresses[0][isPermanentAddressSame]",
            "required": true,
            "name": "addresses[0][isPermanentAddressSame]",
            "label": "Is your current address same as permanent address?",
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "Yes",
                "value": "true"
              },
              {
                "label": "No",
                "value": "false"
              }
            ],
            "ui": {
              "gridType": "fullRow"
            }
          },
          {
            "name": "addresses[1]",
            "type": "address",
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][isPermanentAddressSame]",
                "expectedValue": "false",
                "type": "LEAF"
              },
              "unregister": true
            },
            "options": [
              {
                "fieldId": "mailingCountry",
                "required": true,
                "name": "mailingCountry",
                "isPartOfCollection": true,
                "label": "Country",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                }
              },
              {
                "fieldId": "mailingState",
                "required": true,
                "name": "mailingState",
                "label": "State",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": []
              },
              {
                "fieldId": "mailingDistrict",
                "required": true,
                "name": "mailingDistrict",
                "label": "City",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": []
              }
            ]
          },
          {
            "fieldId": "addresses[1][mailingStreet]",
            "name": "addresses[1][mailingStreet]",
            "label": "Address",
            "type": "input",
            "required": true,
            "validationType": "alphaNumeric",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 5,
                "message": "Please enter a valid address"
              },
              "maxLength": {
                "value": 120,
                "message": "This field cannot be more than 120 characters"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][isPermanentAddressSame]",
                "expectedValue": "false",
                "type": "LEAF"
              },
              "unregister": true
            }
          },
          {
            "name": "addresses[1]",
            "type": "address",
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][isPermanentAddressSame]",
                "expectedValue": "false",
                "type": "LEAF"
              },
              "unregister": true
            },
            "options": [
              {
                "fieldId": "hed__MailingCountry__c",
                "required": true,
                "name": "hed__MailingCountry__c",
                "label": "Country",
                "type": "select",
                "options": [],
                "validations": {
                  "required": "This field is required"
                }
              },
              {
                "fieldId": "hed__MailingState__c",
                "required": true,
                "name": "hed__MailingState__c",
                "label": "State",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                }
              },
              {
                "fieldId": "hed__MailingCity__c",
                "required": true,
                "name": "hed__MailingCity__c",
                "label": "City",
                "type": "select",
                "validations": {
                  "required": "This field is required"
                },
                "options": []
              }
            ]
          },
          {
            "fieldId": "addresses[1][mailingPostalCode]",
            "required": true,
            "name": "addresses[1][mailingPostalCode]",
            "label": "PIN / PO BOX/ ZIP",
            "type": "input",
            "validationType": "alphaNumeric",
            "validations": {
              "required": "This field is required",
              "minLength": {
                "value": 6,
                "message": "Please enter a valid Pin code"
              },
              "maxLength": {
                "value": 6,
                "message": "Please enter a valid Pin code"
              },
              "pattern": {
                "value": "",
                "message": "Please enter a valid Pin code"
              }
            },
            "ui": {
              "grid": {
                "xs": 12,
                "md": 6,
                "lg": 6
              }
            },
            "rule": {
              "effect": "SHOW",
              "condition": {
                "scope": "addresses[0][isPermanentAddressSame]",
                "expectedValue": "false",
                "type": "LEAF"
              },
              "unregister": true
            }
          }
        ]
      },
      {
        "sectionName": "Career Goal Section",
        "apiKeyId": "applicant",
        "subSectionName": "",
        "sectionPosition": 1,
        "sectionVisible": true,
        "sectionType": "form",
        "fields": [
          {
            "fieldId": "career[0][yourWishtoAchieveThroughSICProgram]",
            "required": true,
            "name": "career[0][yourWishtoAchieveThroughSICProgram]",
            "label": "Explain what you would like to achieve through SIC?",
            "type": "multiSelect",
            "disabled": false,
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "Participate in courses and access all materials free of charge",
                "value": "Participate in courses and access all materials free of charge"
              },
              {
                "label": "Experience machine learning tools and real-world problem solving with exciting curriculum",
                "value": "Experience machine learning tools and real-world problem solving with exciting curriculum"
              },
              {
                "label": "Grasp the landscape of data science tools and their applications",
                "value": "Grasp the landscape of data science tools and their applications"
              },
              {
                "label": "Opportunity to meet Samsung employees, industry leaders and field experts",
                "value": "Opportunity to meet Samsung employees, industry leaders and field experts"
              }
            ]
          },
          {
            "fieldId": "career[0][hearAboutSIC]",
            "required": true,
            "name": "career[0][hearAboutSIC]",
            "label": "How did you find out about SIC?",
            "type": "select",
            "validations": {
              "required": "This field is required"
            },
            "options": [
              {
                "label": "Social Media",
                "value": "Social Media"
              },
              {
                "label": "Referral",
                "value": "Referral"
              },
              {
                "label": "School/University",
                "value": "School/University"
              },
              {
                "label": "Event/Conference",
                "value": "Event/Conference"
              },
              {
                "label": "Online Advertisement",
                "value": "Online Advertisement"
              },
              {
                "label": "Samsung Website",
                "value": "Samsung Website"
              },
              {
                "label": "Word of Mouth",
                "value": "Word of Mouth"
              },
              {
                "label": "Career Fair",
                "value": "Career Fair"
              },
              {
                "label": "ESSCI Website",
                "value": "ESSCI Website"
              },
              {
                "label": "Alumni",
                "value": "Alumni"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "stepId": "Upload Documents",
    "stepName": "Photo & Document Upload",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "documentUpload",
    "sections": []
  },
  {
    "stepId": "selectionTest",
    "stepName": "Selection Test",
    "showStepName": false,
    "stepVisible": true,
    "stepPosition": 1,
    "stepType": "selectionTest",
    "sections": []
  },
  {
    "stepId": "summaryWithDeclaration",
    "stepName": "Summary and Declaration",
    "stepPosition": 5,
    "showStepName": true,
    "stepVisible": true,
    "stepType": "summary",
    "voucher": true,
    "sections": []
  }
]
